export default __webpack_public_path__ + "static/builder-hog-6e77c46eb980457f4eec91e4a8a517c6.png";